import React, { useState, useEffect,useContext } from 'react';
import Navbar from './Navbar';
import { Container, Row, Col } from "react-bootstrap";
import { useNavigate,Link, useLocation  } from 'react-router-dom';
import Loader from '../components/Loader';
import projectSearch from '../assets/data/details.json';
import ReactMarkdown from 'react-markdown';
import Select from 'react-select';
import axios from 'axios';
import { UserContext } from '../contexts/UserContext';
import FeedbackWidget from '../components/FeedbackWidget';
import MarkdownToggleList from '../components/MarkdownToggleList';
import FyQuarterSelect from '../components/FyQuarterSelect';
import { CONFIG} from '../config';

const columns = ["Asset", "Primary Technology","Delivery Type","TMS ID","TMS name"];

const ProjectClosure = () => {
 const apiUrl = CONFIG.REACT_APP_BACKEND_URL+'/projectclosure_retrieval';  
  //const apiUrl = 'https://divadevfalcon.azurewebsites.net/projectclosure_retrieval';
  //const apiUrl = 'https://divapilotfalcon-hdbqdbd4gxccdmdd.eastus-01.azurewebsites.net/projectclosure_retrieval';
  //const apiUrl = 'https://divaprodfalcon-grdbddd7c3cvakd3.eastus-01.azurewebsites.net/projectclosure_retrieval'; 
  const projectClosureUrl=CONFIG.REACT_APP_PROJECT_CLOSURE;
    const [loading, setLoading] = useState(false); 
    const [filterColumn, setFilterColumn] = useState(null);
    const [modalOpen, setModalOpen] = useState(false);
    const [searchText, setSearchText] = useState("");
    const [searchbtnChange, setSearchbtnChange] = useState(true);
    const [displayResponse, setDisplayResponse] = useState(false);
    const [allSelected, setAllSelected] = useState(false);
    const [filteredData, setFilteredData] = useState([]);
    const [openStates, setOpenStates] = useState(Array(5).fill(false));
    const [isExpanded, setIsExpanded] = useState(true);
    const [projectClosureWeb, setProjectClosureWeb] = useState([]); 
    const [fy, setfy] = useState([{'value':'FY26-Q1', 'label':'FY26-Q1'}]);
    const [selectedMarket, setSelectedMarket] = useState({'value':'All', 'label':'All'});
    const [selectedCG, setSelectedCG] = useState({'value':'All', 'label':'All'});
    const [selectedTechnology, setSelectedTechnology] = useState({'value':'All', 'label':'All'});
    const [selectedDeliveryType, setSelectedDeliveryType] = useState([{'value':'All', 'label':'All'}]);
    const [error, setError] = useState("");
    const [selectedOptions, setSelectedOptions] = useState({});
    const [challengesAndMitigations, setChallengesAndMitigations] = useState({});
    const [activeTab, setActiveTab] = useState("tab1");
    const [projectOutcomes, setProjectOutcomes] = useState("");
    const [noData, setNoData] = useState(false);
    const { userId } = useContext(UserContext);
    const assetRemove=['NA','N/A','null','nil','No','None','Yes'];
    const [showFeedback, setShowFeedback] = useState(true);
    const [showAll, setShowAll] = useState(false);
    const [displayCol, setdisplayCol] = useState(["Asset", "Primary Technology","Delivery Type","TMS ID","TMS name"]);
    const [fySelectedData, setfySelectedData] = useState({ FY: [], Q: [] });

    const errorMessage="Sorry, I couldn't find an appropriate response";
       

    const accordionData = [
      { title: 'What are the Top 5 Challenges?', content: 'This is content of Accordion 1' },
      { title: 'What are the projects that have -ve EAC?', content: 'This is content of Accordion 2' },
      { title: 'What are the lessons learnt for Projects having client Satisfaction issues?', content: 'This is content of Accordion 3' },
      { title: 'What are the Top 5 reasons for Early closure?', content: 'This is content of Accordion 4' },
      { title: 'What are the Top 5 best practices ?', content: 'This is content of Accordion 5' }
    ];

    const options = Object.keys(projectSearch.governingMarket).map((key) => ({
      value: key,
      label: key
    }));
   
    const optionsCg = selectedMarket
    ? projectSearch.governingMarket[selectedMarket.value].map((val) => ({
        value: val,
        label: val
      }))
    : [];


    const optionstech = (projectSearch.technology).map((item) => ({
      value: item,
      label: item
    }));

    const optionsdt = (projectSearch.deliverytype).map((item) => ({
      value: item,
      label: item
    }));

    const optionsfy = (projectSearch.fyList).map((item) => ({
      value: item,
      label: item
    }));
      
    useEffect(() => {
      const handleClickOutside = (e) => {
        if (!e.target.closest(".filter-popup") && !e.target.closest(".filter-icon")) {
          setModalOpen(false);
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };      
    }, []);

    const toggleAccordion = (index) => {
      const newStates = [...openStates];
      newStates[index] = !newStates[index];
      setOpenStates(newStates);
    };
    const expandAll = () => {setOpenStates(Array(accordionData.length).fill(true)); setIsExpanded(false);}
    const collapseAll = () => {setOpenStates(Array(accordionData.length).fill(false)); setIsExpanded(true);}

    const handleSort = (column) => {
      setSortColumn(column);
  
      const sortedData = [...filteredData].sort((a, b) => {
        if (displayCol.includes(column)) {
          return a[column].localeCompare(b[column], undefined, { numeric: true, sensitivity: "base" });
        } else {
          return (colorPriority[a[column]] || 99) - (colorPriority[b[column]] || 99); // custom color sort
        }
      });
  
      console.log('sortedData',sortedData);
      setFilteredData(sortedData);
    };
  
    const handleFilterClick = (column) => {
      setFilterColumn(column);
      setSearchText("");
      setModalOpen(true);
    };
  
    const handleCheckboxChange = (value) => {
      setSelectedOptions((prev) => ({
        ...prev,
        [value]: !prev[value],
      }));
    };

    const getUniqueOptions = () => {
  if (!filterColumn) return [];

  const options = [...new Set(projectClosureWeb.overallcontext.map(item => item[filterColumn]))];

  return options
    .filter(option =>
      (option ?? "").toString().toLowerCase().includes(searchText.toLowerCase())
    )
    .sort((a, b) => {
      const valA = (a ?? "").toString().toLowerCase();
      const valB = (b ?? "").toString().toLowerCase();
      return valA.localeCompare(valB);
    });
};

  
    const handleSelectAll = () => {
      const options = getUniqueOptions();
      const newSelected = {};
      if (!allSelected) {
        options.forEach((option) => {
          newSelected[option] = true;
        });
      }
      setSelectedOptions(newSelected);
      setAllSelected(!allSelected);
    };

    const displayColumnsData = (col,value) =>{
      if(displayCol.includes(col))
        return value;
      else return '';
    }

    const handleApply = () => {
      if (!filterColumn) return;
  
      const selectedValues = Object.keys(selectedOptions).filter((key) => selectedOptions[key]);
  
      if (selectedValues.length === 0) {
        setFilteredData(projectClosureWeb.overallcontext); // No filter, show all
      } else {
        const newFilteredData = projectClosureWeb.overallcontext.filter((row) =>
          selectedValues.includes(row[filterColumn]?.toString())
        );
        setFilteredData(newFilteredData); //  Update filtered data
      }
      setModalOpen(false);
    };
   

    const selectedChangeMarket = (selected) => {
      console.log('Selected key:', selected);
      setSelectedMarket(selected);
      setSelectedCG({'value':'All','label':'All'}); 
    };

    const isMarkdownNA = (markdownString,outputString) => {
      if (!markdownString) return false;
    
      const cleaned = markdownString
        .replace(/[*_\-`#>\n\r]/g, '') // remove markdown symbols
        .trim()
        .toUpperCase();
    
      return cleaned === 'NA' ? outputString : markdownString;
    };
    

       const projectOutComeApi= async () => {
        try{
          setLoading(true);        
          console.log('inside fetchData',projectOutcomes);
          if(searchbtnChange){
             var dt=[];
                 console.log('fyvalue',fySelectedData.FY);
            const uniqueQuarters = [...new Set(fySelectedData.Q.map(q => q.split("-")[1]))];
            console.log('uniqueQuarters',uniqueQuarters);
            const uniqueFY = [...new Set(fySelectedData.Q.map(q => q.split("-")[0]))];
            console.log('uniqueFY',uniqueFY);
          
            if (
                !selectedDeliveryType ||
                selectedDeliveryType.length === 0 ||
                (selectedDeliveryType.length === 1 &&
                  selectedDeliveryType[0].value === "All")
              ) {
                dt = [];
              } else {
                dt = selectedDeliveryType
                  .filter((item) => item.value !== "All") // remove "All"
                  .map((item) => item.value);
              }
            let fyList = uniqueFY;
            let QList = uniqueQuarters;

           console.log('fyvalue',fySelectedData);
          const postData={
            "query": "project closure portfolio all data",
            "query_type": "closure_projectoutcome",
            "enterprise_id": userId,
            "governingMarket": selectedMarket && selectedMarket?.value && selectedMarket.value!=='All'? selectedMarket?.value:'',                  
            "governingClientGroup":selectedCG && selectedCG?.value && selectedCG.value!=='All'? selectedCG?.value:'',
            "primaryTechnology":selectedTechnology && selectedTechnology?.value && selectedTechnology.value!=='All'? selectedTechnology.value=="Java/J2EE"?'Java':selectedTechnology.value=="AWS/Amazon Web Services"?'AWS':selectedTechnology.value=="SQL Server"?'SQL':selectedTechnology.value:'',
            "deliveryType": dt,
            "custom_search": "False",
            "fy":fyList,
            "quarter":QList            
          } 
        console.log('postData',postData);
        await axios.post(apiUrl, postData, { headers: { 
          'Content-Type': 'application/json'
        }})
        .then(response => {
          setError('');
          const projectOutcomeJson=response.data;
              const context=projectOutcomeJson['what are the top 5 challenges?'].context;
              if(context.some(item => typeof item === 'object' && item !== null)) {
          const others = context.filter(item => item.category && item.category.toLowerCase() === 'other');
          console.log('others',others);
          const rest = context.filter(item => item.category &&  item.category.toLowerCase() !== 'other');
          console.log('rest',rest);
          response.data['what are the top 5 challenges?'].context = [...rest, ...others]; 
        } else response.data['what are the top 5 challenges?'].context = []; 

          const contextAtci=projectOutcomeJson['what are the top 5 challenges for atci led projects?'].context;
          if(contextAtci.some(item => typeof item === 'object' && item !== null)) {         
          const othersAtci = context.filter(item => item.category && item.category.toLowerCase() === 'other');
          console.log('others',othersAtci);
          const restAtci = contextAtci.filter(item => item.category && item.category.toLowerCase() !== 'other');
          console.log('restAtci',restAtci);
          projectOutcomeJson['what are the top 5 challenges for atci led projects?'].context = [...restAtci, ...othersAtci];
          } else projectOutcomeJson['what are the top 5 challenges for atci led projects?'].context =[];
          
          const summaryEarly=isMarkdownNA(projectOutcomeJson['what are the top 5 reasons for early closure?'].overall_summary,'There are no early closures reported');
          projectOutcomeJson['what are the top 5 reasons for early closure?'].overall_summary=summaryEarly;
          const contextEarly=projectOutcomeJson['what are the top 5 reasons for early closure?'].context;
          if(contextEarly.some(item => typeof item === 'object' && item !== null)) {
          console.log('contextEarly',contextEarly);
          const cleanData = contextEarly
          .map(item => {
            const filteredContext = item.dsg_context.filter(
              ctx => ctx.reasonForEarlyClosure !== "" && ctx.reasonForEarlyClosure !== null
            );
            return filteredContext.length > 0
              ? { ...item, dsg_context: filteredContext }
              : null;
          })
          .filter(Boolean); // remove nulls          
          console.log('cleanData',cleanData);
          projectOutcomeJson['what are the top 5 reasons for early closure?'].context=cleanData;
        } else    projectOutcomeJson['what are the top 5 reasons for early closure?'].context=[];
                  
          setProjectOutcomes(projectOutcomeJson)
          setSearchbtnChange(false);
        })
        .catch(error => {
          console.error('Error posting data:', error);
          setError("Failed to fetch data.");
        });    
      }
        
      } catch (err) {
        setError("Failed to fetch data.");
      } finally {
        setLoading(false);
      } 
       }

     
 const onChangeDeliveryType = (selected, actionMeta) => {
    if (!selected || selected.length === 0) {
      setSelectedDeliveryType([{ value: "All", label: "All" }]);
    } else if (actionMeta.option?.value === "All") {
      // If "All" was the last clicked → only keep All
      setSelectedDeliveryType([{ value: "All", label: "All" }]);
    } else {
      // Remove All if it was there and keep others
      const withoutAll = selected.filter(opt => opt.value !== "All");
      setSelectedDeliveryType(withoutAll);
    }
  };



       const fetchData = async () => {
          try{
            if(!userId)
             { setNoData(true); return;}
            setLoading(true);  
            setError('');   
            console.log('inside fetchData');
              console.log('fyvalue',fy,fySelectedData);
            const uniqueFY = [...new Set(fySelectedData.Q.map(q => q.split("-")[0]))];
              console.log('uniqueFY',uniqueFY);
            const uniqueQuarters = [...new Set(fySelectedData.Q.map(q => q.split("-")[1]))];
              console.log('uniqueQuarters',uniqueQuarters);
            var dt=[];
              if (
                !selectedDeliveryType ||
                selectedDeliveryType.length === 0 ||
                (selectedDeliveryType.length === 1 &&
                  selectedDeliveryType[0].value === "All")
              ) {
                dt = [];
              } else {
                dt = selectedDeliveryType
                  .filter((item) => item.value !== "All") // remove "All"
                  .map((item) => item.value);
              }
            let fyList = uniqueFY;
            let QList = uniqueQuarters;
           
            const postData={
              "query": "project closure view all data",
              "query_type": "projectclosure",
              "enterprise_id": userId,
              "governingMarket": selectedMarket && selectedMarket?.value && selectedMarket.value!=='All'? selectedMarket?.value:'',                  
              "governingClientGroup":selectedCG && selectedCG?.value && selectedCG.value!=='All'? selectedCG?.value:'',
              "primaryTechnology":selectedTechnology && selectedTechnology?.value && selectedTechnology.value!=='All'? selectedTechnology.value=="Java/J2EE"?'Java':selectedTechnology.value=="AWS/Amazon Web Services"?'AWS':selectedTechnology.value=="SQL Server"?'SQL':selectedTechnology.value:'',
              "deliveryType": dt,
              "custom_search": "False",
              "fy":fyList,
              "quarter":QList
            }

          console.log('postData',postData);
          await axios.post(apiUrl, postData,  { headers: { 
            'Content-Type': 'application/json'
          }})
          .then(response => {
            console.log('response',response);
            setDisplayResponse(true);
            if(!response.data.overallcontext[0]['toolsOrAssetsUsed'])
                   setError('no data'); 
            console.log('response.data.overallcontext',response.data.overallcontext[0]['toolsOrAssetsUsed']); 
            const overallcontext=response.data.overallcontext;  
            const overallcontextArray=[];        
            overallcontext.forEach(item => {
              console.log('inside projectcloserweb',item);
             // if(!(assetRemove.some(item1 => item1.toLowerCase() === item.toolsOrAssetsUsed.toLowerCase()))){
              for (let key in item) {
                console.log('key',key,item);
                if(key==="toolsOrAssetsUsed"){
                  item['Asset']=item["toolsOrAssetsUsed"];
                } else if(key==="primaryTechnology"){
                  item['Primary Technology']=item["primaryTechnology"];
                } else if(key==="deliveryType"){
                  item['Delivery Type']=item["deliveryType"];
                } else if(key==="tmsId"){
                  item['TMS ID']=item["tmsId"];
                } else if(key==="tmsName"){
                  item['TMS name']=item["tmsName"];
                }
              }
              overallcontextArray.push(item);
          //  }
            });
            response.data.overallcontext=overallcontextArray;
            // if(response.data['Accenture Tools / Assets used']) {
            //   const parts = response.data['Accenture Tools / Assets used'].split('\n-');
            //   response.data['Accenture Tools / Assets used']= parts[0] + parts[1]+ parts.slice(2).map(item => ", " + item).join("");
            //   response.data['Accenture Tools / Assets used']=response.data['Accenture Tools / Assets used'].replace(/undefined/g, "").trim()
            // }
      
           // const blocks = response.data['Challenges and Mitigations'].split(/\n(?=\*\*[^\n]+?:\*\*)/g); // Split by next bold title
            const blocks = response.data['Challenges and Mitigations']?.split(/\n(?=\*\*[^\n]+?:\*\*)/g) || [];

            const rows = [];
            let currentValue = [];
            let current = null;
          
            blocks.forEach((block) => {
              const trimmed = block.trim();
          
              // Check if this is a type block (not Challenges or Challenge)
              if (/^\*\*[^*]+:\*\*$/.test(trimmed)) {
                const typeName = trimmed.replace(/\*\*|\:\*\*/g, '').trim();
          
                // Save current block if exists
                if (current) currentValue.push(current);
          
                current = {
                  type: typeName,
                  Challenges: '',
                  Mitigation: '',
                };
              } else if (trimmed.toLowerCase().startsWith('**challenges:**')) {
                const challengeText = trimmed.replace(/^\s*\*\*\s*challenges\s*:\s*\*\*\s*/i, '').trim();
                if (current) current.Challenges = challengeText;
              } else if (trimmed.toLowerCase().startsWith('**mitigation:**')) {
                const solutionText = trimmed.replace(/^\s*\*\*\s*mitigation\s*:\s*\*\*\s*/i, '').trim();
                if (current) current.Mitigation = solutionText;
              } else {
                // If it's a multi-line value (not a heading), append it to the last known field
                if (current) {
                  if (!current.Challenges && current.Mitigation) {
                    current.Challenges += ' ' + trimmed;
                  } else if (current.Mitigation) {
                    current.Mitigation += ' ' + trimmed;
                  }
                }
              }              
            });
            if (current) currentValue.push(current);
            console.log('current',currentValue);
            if(currentValue && currentValue.length>0){
              currentValue = [...currentValue].sort((a, b) => {
                const typeA = a.type?.toLowerCase();
                const typeB = b.type?.toLowerCase();
              
                if (typeA === 'other' && typeB !== 'other') return 1;
                if (typeA !== 'other' && typeB === 'other') return -1;
                return 0;
              });
            }
            currentValue.forEach((value) => {
              if(!(isMarkdownNA(value.Challenges,'')==='' || isMarkdownNA(value.Mitigation,'')==='' ))
              rows.push(value);
            });

            console.log('responserow',rows);
            setChallengesAndMitigations(rows);
            setProjectClosureWeb(response.data);
            setFilteredData(response.data.overallcontext);
            setActiveTab("tab1");
            setSearchbtnChange(true);
    
          })
          .catch(error => {
            setError("Failed to fetch data.");        
            console.error('Error posting data:', error);
          });    
          
        } catch (err) {
          setError("Failed to fetch data.");
        } finally {
          setLoading(false);
        } 
        }

  return (
    <div className="container">
      <Navbar />      
      <div className='projectHeader' id="projectHeader">
           <span className="projectHeaderTms"> Project Closure Analytics Summary </span>
      </div>
      <Container className="totalproject totalClient ">
      {/* Top Section with About & Export Button */}
      {/* <Row className="align-items-center mb-3">
        <Col md={6} id="about">
          <h3>Filter</h3>
        </Col>
        <Col md={6} className="text-end">
        {/* <div className="btn-group export-btn" role="group">
          <button type="button" className="btn btn-primary dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
            Export
          </button>
          <ul className="dropdown-menu">
          <li><a className="dropdown-item" href="#" onClick={handlePdfDownload}>PDF</a></li>          
          </ul>
        </div> */}
        {/* </Col>
      </Row> */} 
      {/* Gray Background Box */}
      <div className="p-3 bg-light rounded" id="projectLevelSummary">
        <h5 className='summaryTypeHeading'>Select one or more filter criteria</h5>
        <div className="container">
  <div className="row">
    <div className="col-3">Governing Market:
         <Select className="form-control custom-select mr-2" id="inlineFormCustomSelect" options={options}  value={selectedMarket} onChange={selectedChangeMarket} placeholder="Search and select..." isSearchable />
    </div>
    <div className="col-3">IG / Client Group:
          <Select className="form-control custom-select mr-2" id="inlineFormCustomSelect" options={optionsCg}  value={selectedCG} onChange={setSelectedCG} isDisabled={!selectedMarket} placeholder="Search and select..." isSearchable />
   </div>
    <div className="col-3">Technology:
         <Select className="form-control custom-select mr-2" id="inlineFormCustomSelect" options={optionstech}  value={selectedTechnology} onChange={setSelectedTechnology} placeholder="Search and select..." isSearchable />
   </div>    
    <div className="col-3">Financial year:
      <FyQuarterSelect className="form-control custom-select mr-2" onChange={(data) => setfySelectedData(data)} />
          {/* <Select className="form-control custom-select mr-2" isMulti id="inlineFormCustomSelect" options={optionsfy}  value={fy} onChange={setfy} isSearchable /> */}
   </div>
    <div className="col-4">Delivery Type:
        <Select className="form-control custom-select mr-2" isMulti  id="inlineFormCustomSelect" options={optionsdt}  value={selectedDeliveryType} onChange={onChangeDeliveryType} placeholder="Search and select..." isSearchable />
   </div>
     <div className="col-8 form-group mt-3"> 
      <button type="button" className="btn-search btn btn-primary text-end float-end" onClick={fetchData} aria-expanded="false">
      Search
          </button>
          </div>
  </div>
  <div className="row selectfilter">
    <div className="col-3 form-group mr-sm-2">      
    </div>
    <div className="col-2 form-group mr-sm-2">      
    </div>
    <div className="col-3 form-group mr-sm-2">      
    </div>
    <div className="col-3 form-group mr-sm-2">      
    </div>
    <div className="col-3 form-group mr-sm-2">      
    </div>
    <div className="col-4 form-group mr-sm-2">      
      {/* <Select className="form-control custom-select" id="inlineFormCustomSelect" options={optionsdt}  value={selectedDeliveryType} onChange={setSelectedDeliveryType} placeholder="Search and select..." isSearchable /> */}
    </div>
    
  </div>

</div>
      </div>
    {error && displayResponse && <div className='errorClass'><br/>
          <h3>There are no project closure records associated for this category.</h3>
            <p>For further information, please refer to the <a target="_blank" rel="noopener noreferrer" href={projectClosureUrl} >Project Closure</a> details.</p>
        </div>   }
    {!error && displayResponse &&  <div>
      <ul className="nav nav-pills mb-3 displayTab" id="pills-tab" role="tablist">
      <li className="nav-item" role="presentation">
        <button className={`nav-link ${activeTab === "tab1" ? "active" : ""}`}
            onClick={() => setActiveTab("tab1")}>Summary</button>
      </li>
      <li className="nav-item" role="presentation">
        <button  className={`nav-link ${activeTab === "tab2" ? "active" : ""}`}
            onClick={() => {setActiveTab("tab2");projectOutComeApi();}}>Project Outcomes</button>
      </li>
      <li className="nav-item" role="presentation">
        <button className={`nav-link ${activeTab === "tab3" ? "active" : ""}`}
            onClick={() => setActiveTab("tab3")}>Assets</button>
      </li>
      </ul>
    <div className="tab-content" id="pills-tabContent">
    {activeTab === "tab1" && 
      <div className="tab-pane fade show active" id="pills-project_summary" role="tabpanel" aria-labelledby="pills-project_summary-tab">
      <table className="table table-striped smart-table DemographicsTable">
        <tbody>
          <tr>
            <td className='fw-medium'>Accenture Tools / Assets used</td>            
          </tr>
          <tr>
          <td><div><ReactMarkdown>{projectClosureWeb['Accenture Tools / Assets used']}</ReactMarkdown> <a className='blueColor' onClick={() => setActiveTab("tab3")}>For more details click here</a></div> </td>           
          </tr>
          <tr>
            <td className='fw-medium'>Challenges and Mitigations</td>
            </tr>
            <tr>
            {/* <td><ReactMarkdown>{projectClosureWeb['Challenges and Mitigations']}</ReactMarkdown></td> */}
            <table className="smart-table table-bordered table-challenges">
      <thead>
        <tr>
          <th>Category</th>
          <th>Challenges</th>
          <th>Mitigations</th>
        </tr>
      </thead>
      <tbody>
        {challengesAndMitigations && challengesAndMitigations.length > 0 ?( challengesAndMitigations.map((row, idx) => (
          !(row.Challenges=='NA' && row.Mitigation=='NA') &&
         <tr key={idx}>
            <td>{row.type}</td>
            <td><MarkdownToggleList markdownText={row.Challenges} /></td>
            <td><MarkdownToggleList markdownText={row.Mitigation} /></td>
          </tr>
        ))):(<tr><td colSpan="3" style={{ textAlign: 'center' }}>
          No data available
        </td></tr>)}
      </tbody>
    </table>
          <br/>
          </tr>
          <tr>
            <td className='fw-medium'>Lessons Learnt</td>
            </tr>
            <tr>
            <td><MarkdownToggleList markdownText={projectClosureWeb['Lessons Learnt Recommended']} /> </td>
          </tr>
        </tbody>
      </table>
        </div> }
        {activeTab === "tab2" && 
      <div className="tab-pane fade show active" id="pills-project_outcomes" role="tabpanel" aria-labelledby="pills-project_outcomes-tab">
            <div className="d-inline-flex rounded-pill overflow-hidden border border-1 displayExpandAll" id="displayExpandAll">
            <button
              className={`btn ${!isExpanded ? 'text-white bg-purple' : 'bg-white'} rounded-0`}
              onClick={expandAll}
              style={{ borderRight: '1px solid #ccc' }}
            >
              Expand All
            </button>
            <button
              className={`btn ${isExpanded ? 'text-white bg-purple' : 'bg-white'} rounded-0`}
              onClick={collapseAll}
            >
              Collapse all
            </button>
      
          </div>
          <div className="accordion accordion-flush">
            {/* {accordionData.map((item, idx) => ( */}
              <div key='0'>
                <div
                  className="accordion-item"
                  style={{ cursor: 'pointer',border: '0px' }} 
                  onClick={() => toggleAccordion('0')}
                >
                   <h2 className="accordion-header">
                    <button className='accordion-button'>
                    <strong>What are the top 5 challenges?</strong>
                    </button>
                    </h2>
                </div>
                {openStates['0'] && (
                  <div className="p-2 border-top">
                    
                  <div><ReactMarkdown>{projectOutcomes?.["what are the top 5 challenges?"]?.overall_summary && projectOutcomes["what are the top 5 challenges?"].overall_summary=='NA'?'':projectOutcomes["what are the top 5 challenges?"].overall_summary}</ReactMarkdown></div>
                   <div >               
                      {projectOutcomes["what are the top 5 challenges?"].context && projectOutcomes["what are the top 5 challenges?"].context.length>0 && projectOutcomes["what are the top 5 challenges?"].context.map((col) => (
                       <div>                
                      {col.category ?   <div className="accordion" id="accordionExample">
            <div className="accordion-item">
              <h2 className="accordion-header" id={'headingOne'+col.category.replace(/ /g, "-")}>
                <button
                  className="accordion-button"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target={'#collapseOne'+col.category.replace(/ /g, "-")}
                  aria-expanded="true"
                  aria-controls={'collapseOne'+col.category.replace(/ /g, "-")}
                >
                  {"View challenges for "+col.category}
                </button>
              </h2>
              <div
                id={'collapseOne'+col.category.replace(/ /g, "-")}
                className="accordion-collapse collapse"
                aria-labelledby={'headingOne'+col.category.replace(/ /g, "-")}
                data-bs-parent="#accordionExample"
              >
                <div className="accordion-body">
                           <table class="table smart-table table-striped displaySummary">  
                                       <tr>
                                         <th>Challenges Summary</th>
                                         <th>Mitigation Summary</th>
                                  
                                      </tr>
                                      <tr>
                                      <td><MarkdownToggleList markdownText={col.challenges_summary} /></td>
                                  
                                         <td><MarkdownToggleList markdownText={col.mitigation_summary} /></td>
                                      </tr>                         
                           </table>
                        <table class="table smart-table displaySummary">  
                                      <tr>
                                        <th>Client – TMS name</th>
                                        <th>Base Market</th>
                                        <th>DSG</th>
                                        <th>Challenges</th>
                                        <th>Mitigation</th>
                                      </tr>
                                      <tbody>
                                      {col.category_context.map((c) => (                
                                      <tr>
                                        <td>{c.client+' - '+ c.tmsName}</td>
                                        <td>{c.market}</td>
                                        <td>{c.dominantServiceGroup}</td>
                                        <td>{c.challenges}</td>
                                        <td>{c.mitigation}</td>
                                      </tr>
                                      
                                  ))}  
                                  </tbody>                          
                          </table>
                </div>
              </div>
            </div>
      
          </div>
                      : ''  }
                          </div>
                      ))}
                    
                  </div>
                  </div>
                )}
              </div>
              <div key='1'>
                <div
                  className="accordion-item"
                  style={{ cursor: 'pointer',border: '0px' }} 
                  onClick={() => toggleAccordion('1')}
                >
                   <h2 className="accordion-header">
                    <button className='accordion-button'>
                    <strong>What are the lessons learnt for projects having client satisfaction issues?</strong>
                    </button>
                    </h2>
                </div>
                {openStates['1'] && (
                           <div className="p-2 border-top">
                             <div><ReactMarkdown>{projectOutcomes?.["what are the lessons learnt for projects having client satisfaction issues?"]?.overall_summary && projectOutcomes["what are the lessons learnt for projects having client satisfaction issues?"].overall_summary!=='NA'?projectOutcomes["what are the lessons learnt for projects having client satisfaction issues?"].overall_summary:''}</ReactMarkdown> </div>
                             <div>
                           {projectOutcomes["what are the lessons learnt for projects having client satisfaction issues?"].context && projectOutcomes["what are the lessons learnt for projects having client satisfaction issues?"].context.length>0 && projectOutcomes["what are the lessons learnt for projects having client satisfaction issues?"].context.map((col) => (
                             
                             <div>    {col.dominantServiceGroup ?               
                                 <div className="accordion" id="accordionExample1">
                     <div className="accordion-item">
                       <h2 className="accordion-header" id={'two'+col.dominantServiceGroup.replace(/ /g, "-")}>
                         <button
                           className="accordion-button"
                           type="button"
                           data-bs-toggle="collapse"
                           data-bs-target={'#collapseTwo'+col.dominantServiceGroup.replace(/ /g, "-")}
                           aria-expanded="true"
                           aria-controls={'collapseTwo'+col.dominantServiceGroup.replace(/ /g, "-")}
                         >
                           {col.dominantServiceGroup}
                         </button>
                       </h2>
                       <div
                         id={'collapseTwo'+col.dominantServiceGroup.replace(/ /g, "-")}
                         className="accordion-collapse collapse show"
                         aria-labelledby={'two'+col.dominantServiceGroup.replace(/ /g, "-")}
                         data-bs-parent="#accordionExample1"
                       >
                         <div className="accordion-body">
                         <table class="table smart-table table-striped">  
                                             
                                               <tr>
                                                  <td><strong>Summary of Leasson Learnt</strong></td>
                                                  </tr><tr>
                                                  <td><MarkdownToggleList markdownText={col.dsg_summary} /></td>
                                               </tr>                         
                                    </table>                    
                                 <table class="table smart-table table-challenges">  
                                               <tr>
                                                 <th>Client – TMS name</th>
                                                 <th>Base Market</th>
                                                 <th>Reasons For Project Closure</th>
                                               </tr>
                                               <tbody>
                                               {col.dsg_context.map((c) => {
                                                 let mitigation='';
                                                 let ChallengesDetails='';
                                                 c["challengesAndMitigation"].map((ch)=> {
                                                       //newSelected[option] = true;
                                                       ChallengesDetails='\r\n\n**'+ch.category+'**\r\n\n'+ch.challenges;
                                                       mitigation='\r\n\n**'+ch.category+'**\r\n\n'+ch.mitigation;
                                                     });            
                                                     return (
                                                     <tr>
                                                 <td>{c.client+' - '+ c.tmsName}</td>
                                                 <td>{c.market}</td>
                                                 <td><ReactMarkdown>{c.reasonsForProjectClosureComments}</ReactMarkdown></td>
                                               </tr> )
                                               
                                           })}  
                                           </tbody>                          
                                   </table>
                         </div>
                       </div>
                     </div>
               
                   </div>
                               : ''  }  
                                   </div>
                               ))}
                           </div>
                           </div>
                         )}
              </div>
              <div key='2'>
                <div
                  className="accordion-item"
                  style={{ cursor: 'pointer',border: '0px' }} 
                  onClick={() => toggleAccordion('2')}
                >
                   <h2 className="accordion-header">
                    <button className='accordion-button'>
                    <strong> What are the top 5 reasons for early closure?</strong>
                    </button>
                    </h2>
                </div>
                {openStates['2'] && (
                  <div className="p-2 border-top">
                  <div><ReactMarkdown>{projectOutcomes?.["what are the top 5 reasons for early closure?"]?.overall_summary && projectOutcomes["what are the top 5 reasons for early closure?"].overall_summary!=='NA'?projectOutcomes["what are the top 5 reasons for early closure?"].overall_summary:''}</ReactMarkdown> </div>
                  {projectOutcomes["what are the top 5 reasons for early closure?"].context && projectOutcomes["what are the top 5 reasons for early closure?"].context.length>0 && projectOutcomes["what are the top 5 reasons for early closure?"].context.map((col) => (
                    <div>
                 {col.dominantServiceGroup ?  <div className="accordion" id="accordionExample">
            <div className="accordion-item">
              <h2 className="accordion-header" id={'headingthree'+col.dominantServiceGroup.replace(/ /g, "-")}>
                <button
                  className="accordion-button"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target={'#collapseThree'+col.dominantServiceGroup.replace(/ /g, "-")}
                  aria-expanded="true"
                  aria-controls={'collapseThree'+col.dominantServiceGroup.replace(/ /g, "-")}
                >
                  {col.dominantServiceGroup}
                </button>
              </h2>
              <div
                id={'collapseThree'+col.dominantServiceGroup.replace(/ /g, "-")}
                className="accordion-collapse collapse"
                aria-labelledby={'headingThree'+col.dominantServiceGroup.replace(/ /g, "-")}
                data-bs-parent="#accordionExample"
              >
                <div className="accordion-body">
                           <table class="table smart-table table-striped">  
                                       <tr>
                                         <th>Summary of Reasons For Early Closure</th> </tr><tr>
                                         <td><MarkdownToggleList markdownText={col.dsg_summary} /></td>
                                      </tr>                        
                           </table>
                        <table class="table smart-table displaySummary">  
                                      <tr>
                                        <th>Client – TMS name</th>
                                        <th>Base Market</th>
                                        <th>Reason For Early Closure</th>
                                      </tr>
                                      <tbody>
                                      {col.dsg_context.map((c) => {  
                                        let mitigation='';
                                        let ChallengesDetails='';
                                        c["challengesAndMitigation"].map((ch)=> {
                                              //newSelected[option] = true;
                                              ChallengesDetails='\r\n\n**'+ch.category+'**\r\n\n'+ch.challenges;
                                              mitigation='\r\n\n**'+ch.category+'**\r\n\n'+ch.mitigation;
                                            });            
                                            return (  
                                              c.reasonForEarlyClosure && c.reasonForEarlyClosure!=='' &&  (            
                                      <tr>
                                        <td>{c.client+' - '+ c.tmsName}</td>
                                        <td>{c.market}</td>
                                        <td><ReactMarkdown>{c.reasonForEarlyClosure}</ReactMarkdown></td>
                                      </tr> ) 
                                      
                                  )})}  
                                  </tbody>                          
                          </table>
                </div>
              </div>
            </div>
      
                        </div>  : ''  }
          </div>
          ))
          }
          
          
                  </div>
               )} 
              </div>
              <div key='3'>
                <div
                  className="accordion-item"
                  style={{ cursor: 'pointer',border: '0px' }} 
                  onClick={() => toggleAccordion('3')}
                >
                   <h2 className="accordion-header">
                    <button className='accordion-button'>
                    <strong>What are the top 5 challenges for ATCI led projects?</strong>
                    </button>
                    </h2>
                </div>
                {openStates['3'] && (
                  <div className="p-2 border-top">
                  <div><ReactMarkdown>{projectOutcomes?.[ "what are the top 5 challenges for atci led projects?"]?.overall_summary && projectOutcomes[ "what are the top 5 challenges for atci led projects?"].overall_summary!=='NA'?projectOutcomes[ "what are the top 5 challenges for atci led projects?"].overall_summary:''}</ReactMarkdown> </div>          
                       {projectOutcomes["what are the top 5 challenges for atci led projects?"].context && projectOutcomes["what are the top 5 challenges for atci led projects?"].context.length>0 && projectOutcomes["what are the top 5 challenges for atci led projects?"].context.map((col) => ( <div>
             {col.category ?
                       <div className="accordion" id="accordionExample">
            <div className="accordion-item">
              <h2 className="accordion-header" id={'headingthree'+col.category.replace(/ /g, "-")}>
                <button
                  className="accordion-button"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target={'#collapseThree'+col.category.replace(/ /g, "-")}
                  aria-expanded="true"
                  aria-controls={'collapseThree'+col.category.replace(/ /g, "-")}
                >
                  {col.category}
                </button>
              </h2>
              <div
                id={'collapseThree'+col.category.replace(/ /g, "-")}
                className="accordion-collapse collapse"
                aria-labelledby={'headingThree'+col.category.replace(/ /g, "-")}
                data-bs-parent="#accordionExample"
              >
                <div className="accordion-body">
                           <table class="table smart-table table-striped displaySummary">  
                                       <tr>
                                         <th>Challenges Summary</th>
                                         <th>Mitigation Summary</th>
                                      </tr>
                                      <tr>
                                      <td><MarkdownToggleList markdownText={col.challenges_summary} /></td>
                                  
                                         <td><MarkdownToggleList markdownText={col.mitigation_summary} /></td>
                                      </tr>                         
                           </table>
                        <table class="table smart-table displaySummary">  
                                      <tr>
                                        <th>Client – TMS name</th>
                                        <th>Base Market</th>
                                        <th>Challenges</th>
                                        <th>Mitigation</th>
                                      </tr>
                                      <tbody>
                                      {col.category_context.map((c) => (  
                                      <tr>
                                        <td>{c.client+' - '+ c.tmsName}</td>
                                        <td>{c.market}</td>
                                        <td><ReactMarkdown>{c.challenges}</ReactMarkdown></td>
                                        <td><ReactMarkdown>{c.mitigation}</ReactMarkdown></td>
                                      </tr>
                                      
                                  ))} 
                                  </tbody>                          
                          </table>
                </div>
              </div>
            </div>
      
               </div> : ''  }  </div> ))
          }
                  </div>
                )}
              </div>
              <div key='4'>
                <div
                  className="accordion-item"
                  style={{ cursor: 'pointer',border: '0px' }} 
                  onClick={() => toggleAccordion('4')}
                >
                   <h2 className="accordion-header">
                    <button className='accordion-button'>
                    <strong> What are the top 5 things that could be done better?</strong>
                    </button>
                    </h2>
                </div>
                {openStates['4'] && (
                  <div className="p-2 border-top">
                  <div><MarkdownToggleList markdownText={projectOutcomes?.[ "what are the top 5 things that could be done better?"]?.overall_summary && projectOutcomes[ "what are the top 5 things that could be done better?"].overall_summary!=='NA'?projectOutcomes[ "what are the top 5 things that could be done better?"].overall_summary:''} />
                   </div>
                  <div>
                  {projectOutcomes["what are the top 5 things that could be done better?"].context && projectOutcomes["what are the top 5 things that could be done better?"].context.length>0 && projectOutcomes["what are the top 5 things that could be done better?"].context.map((col) => (
                    <div>
             {col.dominantServiceGroup ?     <div className="accordion" id="accordionExample">
            <div className="accordion-item">
              <h2 className="accordion-header" id={'headingthree'+col.dominantServiceGroup.replace(/ /g, "-")}>
                <button
                  className="accordion-button"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target={'#collapseThree'+col.dominantServiceGroup.replace(/ /g, "-")}
                  aria-expanded="true"
                  aria-controls={'collapseThree'+col.dominantServiceGroup.replace(/ /g, "-")}
                >
                  {col.dominantServiceGroup}
                </button>
              </h2>
              <div
                id={'collapseThree'+col.dominantServiceGroup.replace(/ /g, "-")}
                className="accordion-collapse collapse"
                aria-labelledby={'headingThree'+col.dominantServiceGroup.replace(/ /g, "-")}
                data-bs-parent="#accordionExample"
              >
                <div className="accordion-body">
                           <table class="table smart-table table-striped">  
                                       <tr>
                                         <th>Summary of Improvement Areas</th></tr><tr>
                                         <td><MarkdownToggleList markdownText={col.dsg_summary} /></td>
                                      </tr>                        
                           </table>
                        <table class="table smart-table displaySummary">  
                                      <tr>
                                        <th>Client – TMS name</th>
                                        <th>Base Market</th>
                                        <th>Project Improvement</th>
                                      </tr>
                                      <tbody>
                                      {col.dsg_context.map((c) => {  
                                        let mitigation='';
                                        let ChallengesDetails='';
                                        c["challengesAndMitigation"].map((ch)=> {
                                              //newSelected[option] = true;
                                              ChallengesDetails='\r\n\n**'+ch.category+'**\r\n\n'+ch.challenges;
                                              mitigation='\r\n\n**'+ch.category+'**\r\n\n'+ch.mitigation;
                                            });            
                                            return (              
                                      <tr>
                                        <td>{c.client+' - '+ c.tmsName}</td>
                                        <td>{c.market}</td>
                                        <td><ReactMarkdown>{c.projectImprovement}</ReactMarkdown></td>
                                      </tr>
                                      
                                  )})}  
                                  </tbody>                          
                          </table>
                </div>
              </div>
            </div>
      
          </div>  : ''  } </div>
          ))
          }
                  </div>
                  </div>
                )}
              </div>
      
         {/* //   ))} */}
          </div>
            </div> }
            {activeTab === "tab3" &&       
      <div className="tab-pane fade show active" id="pills-assets" role="tabpanel" aria-labelledby="pills-assets-tab">
             <Container className="mt-4 metricsTab">    
              <div className='totalAssets'>Total Assets Records:{filteredData.length?' '+filteredData.length:' '+0}</div>    
             <div className="table-wrapper" id="table-wrapper">
      <table className="table table-bordered smart-table assestTable">
        <thead>
          <tr>
            {columns.map((col) => (
              <th key={col} className="position-relative">
                <div className="d-flex align-items-center justify-content-between">
                  {col}
                  {displayCol.includes(col) && (
                  <i className="bi bi-filter" style={{ width: "16px", height: "16px", cursor: "pointer" }} onClick={() => handleFilterClick(col)}></i>
                )}
                  </div>

                {modalOpen && filterColumn === col && (
                  <div
                    className="border p-2 bg-white shadow-sm position-absolute filter-popup"
                    style={{
                      top: "100%",
                      left: "0",
                      width: "250px",
                      zIndex: 1050,
                    }}
                  >
                    <div className="mb-2 fw-bold">{`Filter ${col}`}</div>
                    <div className="input-container">
                        <input
                          type="text"
                          className="form-control mb-2 input-underline"
                          placeholder="Search..."
                          value={searchText}
                          onChange={(e) => setSearchText(e.target.value)}
                        />
                        <i className="bi bi-search search-icon"></i> 
                     </div>
                    <div className="form-check mb-2">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="selectAll"
                        checked={allSelected}
                        onChange={handleSelectAll}
                      />
                      <label className="form-check-label selectAllLabel" htmlFor="selectAll">
                        Select All
                      </label>
                    </div>
                    <hr/>
                    <div style={{ maxHeight: "150px", overflowY: "auto" }}>
                      {getUniqueOptions().map((option, idx) => (
                        <div className="form-check" key={idx}>
                          <input
                            className="form-check-input selectAllInput"
                            type="checkbox"
                            id={`check-${option}`}
                            checked={!!selectedOptions[option]}
                            onChange={() => handleCheckboxChange(option)}
                          />
                          <label
                            className="form-check-label selectAllLabel"
                            htmlFor={`check-${option}`}
                          >
                            {option}
                          </label>
                        </div>
                      ))}
                    </div>

                    <div className="d-flex justify-content-end gap-2 mt-2">
                      <button
                        className="btn btn-sm btn-secondary"
                        onClick={() => setModalOpen(false)}
                      >
                        Close
                      </button>
                      <button
                        className="btn btn-sm btn-primary"
                        onClick={handleApply}
                      >
                        Apply
                      </button>
                    </div>
                  </div>
                )}
              </th>
            ))}
          </tr>
        </thead>

        <tbody>
          {filteredData.map((row, idx) => (
            <tr key={idx} className='clienttr'>
                  {columns.map((col) => {
                   // const cellValue = row[col];
                    //console.log('row',row,col,row[col]);
                    //const className = displayColumnsData(col,row[col]); // assuming "Green" or "green"
                    //console.log('className',className);
                   // const title = titleMap[cellValue] || '';
                  //  console.log('title',title);
                    
                    return (
                      <td key={col} title={row[col]}>
                        {row[col]}
                      </td>
                    );
                  })}
            </tr>           
          ))}
        </tbody>
      </table>
      </div>
             </Container>             
      </div> }
      <div className="">
        <div className='datasource'>Source: <a target="_blank" rel="noopener noreferrer" href={projectClosureUrl}>Project Closure</a></div>
        <div className='dataemailsource'>For any help, please write to <a href="mailto:DiVA-Support@accenture.com">DiVA-Support</a></div>
      </div>
      <br/>
      {showFeedback && (<FeedbackWidget moduleName="projectclosure_Web" onSubmit={() => setShowFeedback(false)}/>)}   </div>

    <div className="footerText">Content Generated by Gen AI, limiting accuracy in few cases. Please use at your own discretion.</div>

    </div>  }
    {loading && <Loader />} 
    </Container>    
    </div>
  );
};

export default ProjectClosure;
